import FlowTypes from 'new/components/flows/types/flowTypes';
import {
  FLOW_TYPE_API_SERVER,
  FLOW_TYPE_CUSTOM,
  FLOW_TYPE_RAG,
  FLOW_TYPE_REPLICATION,
} from '../constants/pipelineConstants';

export function getResourceEntity(
  flowNode: any,
  entities: any,
  merge = true,
  retainProperties = [],
) {
  if (!flowNode && !merge) {
    return null;
  }

  const { data_source_id, data_set_id, data_sink_id } = flowNode || {};
  let resource: any;

  switch (flowNode?.type) {
    case 'SOURCE':
      resource = entities?.sources?.[data_source_id];
      break;

    case 'DATA_SET':
      resource = entities?.dataSets?.[data_set_id];
      break;

    case 'DATA_SINK':
      resource = entities?.sinks?.[data_sink_id];
      break;
  }

  if (merge) {
    if (!flowNode && !resource) {
      return null;
    }

    const merged = { ...flowNode, ...resource };

    if (retainProperties.length) {
      retainProperties.forEach((prop) => {
        merged[prop] = flowNode[prop];
      });
    }

    return merged;
  }

  return resource;
}

export function isSingleDestinationChainFlow(flowType: any) {
  return (
    flowType === FlowTypes.spark ||
    flowType === FlowTypes.in_memory ||
    flowType === FlowTypes.custom ||
    flowType === FlowTypes.replication
  );
}

export function isSingleChainFlow(flowType: any) {
  return (
    flowType === FlowTypes.spark ||
    flowType === FlowTypes.in_memory ||
    flowType === FlowTypes.custom
  );
}

export function isCapsuleCluster(data: any): boolean {
  return data?.cluster?.cluster_type === 'capsule';
}

/**
 * Determines whether record counts should be hidden for a resource object.
 * Convenience function that extracts flow_type from a resource object.
 *
 * @param resource - Resource object containing flow_type property
 * @returns boolean - true if records should be hidden, false otherwise
 */
export function shouldHideRecordsForResource(resource: any): boolean {
  const flowType = resource?.flow_type;

  return flowType === FLOW_TYPE_REPLICATION || flowType === FLOW_TYPE_CUSTOM;
}

/**
 * Determines whether a flow gets the Recent Usage Trends (daily metrics) section.
 * Mirrors the source Overview, which omits its metrics panel for query-prompt (RAG)
 * and API server origins — those flows don't produce per-run processing metrics.
 *
 * @param flow - Flow resource (flow node merged with its origin resource)
 * @returns boolean - true if the daily metrics section should be shown
 */
export function shouldShowFlowDailyMetrics(flow: any): boolean {
  if (!flow?.origin_node_id) return false;

  const flowType = flow.flow_type;
  const nodeType = flow.node_type;

  return (
    flowType !== FLOW_TYPE_RAG &&
    flowType !== FLOW_TYPE_API_SERVER &&
    nodeType !== 'query_prompt' &&
    nodeType !== 'api_server'
  );
}
